import {Injectable} from '@angular/core';
import {Observable, of} from "rxjs";
import {FormGeneratorService} from "../../components/common/fields/form-generator.service";
import {FieldDefinition} from "../../model/field-definition";

@Injectable({
  providedIn: 'root'
})
export class RejectRequestFormGeneratorService implements FormGeneratorService {

  constructor() {
  }

  getQuestions(): Observable<FieldDefinition<any>[]> {
    const questions = [
      new FieldDefinition<string>({
        key: "rejectReason",
        label: 'Merci de préciser le motif du rejet de la demande',
        type: 'textarea',
        value: '',
        required: true,
        warn: 'Attention, celui-ci apparaitra dans le mail de retour du client.',
        order: 1
      })
    ];
    return of(questions.sort((a, b) => a.order - b.order));
  }
}
